var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwapButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "3815613e-40f8-473b-bc17-d813e85b4d06",
    d: "M15.812 17.628l4.125-.003-6 6.375-6-6.375h4.125V7.5h3.75v10.128zM7.938 6.372V16.5h-3.75V6.375H.062l6-6.375 6 6.375-4.124-.003z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b3815613e-40f8-473b-bc17-d813e85b4d06",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#3815613e-40f8-473b-bc17-d813e85b4d06"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#3815613e-40f8-473b-bc17-d813e85b4d06"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapButton);
export default __webpack_public_path__ + "static/media/swap-button.eba7fc0a62e2cd98df9df6c5a490c501.svg";
export { ForwardRef as ReactComponent };